import { render, staticRenderFns } from "./MiniEcg.vue?vue&type=template&id=10cc1080&scoped=true&"
import script from "./MiniEcg.vue?vue&type=script&lang=js&"
export * from "./MiniEcg.vue?vue&type=script&lang=js&"
import style0 from "./MiniEcg.vue?vue&type=style&index=0&id=10cc1080&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc1080",
  null
  
)

export default component.exports